export interface IAccountsPayableOpo {
    opoId: number,
    opoAlias: string,
    currentSemester: number,
    lastSemester: number,
    prevSemester: number,
    older: number,
    total: number,
    payNow: number,
    hasAch: boolean,
    achApproved: boolean,
    centerId: number,
    achAccountNumber?: string,
    achRoutingNumber?: string,
    compAchAccountNumber?: string,
    compAchRoutingNumber?: string,
    confirmationAmount?: number,
    confirmationNumber?: string
}